export default __webpack_public_path__ + "static/media/9.6ba5fa4b.jpg";